<template>
    <div class="mt-2 mt-md-3 mt-xl-4">
        <div class="row">
            <div class="col-12">
                <div class="lead fw-bold" v-html="legalMention.title" />
                <div class="small" v-html="legalMention.text" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    legalMention: {
      type: Object,
      required: true
    },
  }
}
</script>

<style scoped lang="scss">

</style>
